import { DocumentNode, useMutation } from '@apollo/client';

import { graphql } from '../gql';
import { GET_CLAIM } from './claim.query';

export const REMOVE_CLAIM_CONTACT = graphql(`
  mutation RemoveClaimContact($claimUuid: String!, $claimantUuid: String!) {
    removeClaimContact(claimUuid: $claimUuid, claimantUuid: $claimantUuid)
  }
`);

export interface RemoveClaimContactInput {
  claimUuid: string;
  claimantUuid: string;
}

export function useRemoveClaimContactMutation() {
  const [removeClaimContactMutation, { loading, error }] = useMutation(
    REMOVE_CLAIM_CONTACT as unknown as DocumentNode,
    {
      refetchQueries: [GET_CLAIM],
      awaitRefetchQueries: true,
    }
  );

  const removeClaimContact = async (input: RemoveClaimContactInput) => {
    const response = await removeClaimContactMutation({
      variables: {
        claimUuid: input.claimUuid,
        claimantUuid: input.claimantUuid,
      },
    });
    return response.data?.removeClaimContact;
  };

  return {
    removeClaimContact,
    loading,
    error,
  };
}
